<template>
  <div class="certification-page">
    <div class="certification-header">
      <div>
        <h2>Certification</h2>
        <p>NIM Certified Adviser status</p>
      </div>
      <el-button type="primary" :loading="updating" @click="updateStatus">
        Update Certification Status
      </el-button>
    </div>

    <el-card class="status-card" shadow="never" v-loading="loading">
      <div class="status-row">
        <span>Status</span>
        <el-tag :type="statusType">{{ statusLabel }}</el-tag>
      </div>
      <div class="status-row">
        <span>Current Level</span>
        <strong>{{ certification.certification_title || '-' }}</strong>
      </div>
      <div class="status-row">
        <span>LF Raw Score</span>
        <strong>{{ certification.certification_score || 0 }}</strong>
      </div>
      <div class="status-row">
        <span>Last Checked</span>
        <strong>{{ formatTime(certification.certification_checked_at) }}</strong>
      </div>
    </el-card>

    <el-table :data="history" border style="width: 100%; margin-top: 20px;">
      <el-table-column prop="title" label="Level"></el-table-column>
      <el-table-column prop="score" label="Score" width="100"></el-table-column>
      <el-table-column label="Changed At" width="190">
        <template slot-scope="scope">
          {{ formatTime(scope.row.changed_at) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import { getNIMCertificationStatus, updateNIMCertificationStatus } from '../service'

export default {
  name: 'Certification',
  data() {
    return {
      loading: false,
      updating: false,
      certification: {}
    }
  },
  computed: {
    contactId() {
      return Cookie.get('loginId') || ''
    },
    history() {
      return this.certification.certification_history || []
    },
    statusType() {
      return this.certification.certification_status === 'certified' ? 'success' : 'warning'
    },
    statusLabel() {
      return this.certification.certification_status === 'certified' ? 'Certified' : 'Pending'
    }
  },
  mounted() {
    this.fetchStatus()
  },
  methods: {
    fetchStatus() {
      if (!this.contactId) return
      this.loading = true
      getNIMCertificationStatus({ contact_id: this.contactId }).then((res) => {
        if (res && res.code === 0) {
          this.certification = res.data || {}
        } else {
          this.$message.error((res && res.msg) || 'Failed to load certification status.')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    updateStatus() {
      if (!this.contactId) return
      this.updating = true
      updateNIMCertificationStatus({ contact_id: this.contactId }).then((res) => {
        if (res && res.code === 0) {
          this.$message.success(res.msg === 'certification_updated' ? 'Certification updated.' : 'Certification checked.')
          this.fetchStatus()
        } else {
          this.$message.error((res && res.msg) || 'Certification update failed.')
        }
      }).finally(() => {
        this.updating = false
      })
    },
    formatTime(value) {
      const ts = Number(value || 0)
      if (!ts) return '-'
      return new Date(ts * 1000).toLocaleString()
    }
  }
}
</script>

<style scoped>
.certification-page {
  padding: 24px;
}

.certification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.certification-header h2 {
  margin: 0;
  color: #303133;
}

.certification-header p {
  margin: 6px 0 0;
  color: #909399;
}

.status-card {
  max-width: 620px;
}

.status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 42px;
  border-bottom: 1px solid #ebeef5;
}

.status-row:last-child {
  border-bottom: 0;
}
</style>
